/*
 * Pre-order levertijd per artikel naar de checkout.
 * Bij klik op "Afrekenen" zet dit script op elke pre-order regel een regel-eigenschap,
 * bv. "Levertijd: Pre-order – verwacht vanaf 20 oktober". Shopify toont die onder het
 * artikel in de checkout, in de order en in de orderbevestiging.
 * Data komt uit <script data-preorder-sync> in snippets/snippet-cart-notification-links.liquid.
 */
(function () {
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var busy = false;

  function readData(btn) {
    var scope = btn.closest('#cart-notification-links') || document;
    var node = scope.querySelector('script[data-preorder-sync]') || document.querySelector('script[data-preorder-sync]');
    if (!node) return null;
    try { return JSON.parse(node.textContent); } catch (e) { return null; }
  }

  function sync(data) {
    return fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var chain = Promise.resolve();
        (cart.items || []).forEach(function (item) {
          var want = data.lines[item.key] || '';
          var props = Object.assign({}, item.properties || {});
          var changed = false;
          data.labels.concat([data.label]).forEach(function (l) {
            if (!(l in props)) return;
            if (want && l === data.label && props[l] === want) return;
            delete props[l];
            changed = true;
          });
          if (want && props[data.label] !== want) {
            props[data.label] = want;
            changed = true;
          }
          if (!changed) return;
          chain = chain.then(function () {
            return fetch(root + 'cart/change.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify({ id: item.key, quantity: item.quantity, properties: props })
            });
          });
        });
        return chain;
      });
  }

  function proceed(btn) {
    var form = btn.form || document.getElementById('cart');
    btn.dataset.preorderSynced = '1';
    if (form && typeof form.requestSubmit === 'function') {
      form.requestSubmit(btn);
    } else if (form) {
      var input = document.createElement('input');
      input.type = 'hidden';
      input.name = 'checkout';
      form.appendChild(input);
      form.submit();
    } else {
      window.location.href = root + 'checkout';
    }
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('button[name="checkout"]');
    if (!btn || btn.disabled || btn.dataset.preorderSynced === '1') return;
    var data = readData(btn);
    if (!data || !data.lines) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    if (busy) return;
    busy = true;
    btn.setAttribute('aria-busy', 'true');
    sync(data)
      .catch(function (err) { console.warn('[preorder] sync mislukt, door naar checkout', err); })
      .then(function () { busy = false; proceed(btn); });
  }, true);
})();
